exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deactivate-modal .modal[data-v-4a27f73a]{position:relative;top:auto;bottom:auto;right:auto;left:auto;display:block;z-index:1;background:transparent!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/activation/ActivationResult.vue?vue&type=style&index=0&id=4a27f73a&prod&scoped=true&lang=css&
// module id = 1420
// module chunks = 0